import React from 'react';
import PropTypes from 'prop-types';

function CheckHollowIcon({ color = 'black', width = 14, height = 14, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00065 13.6663C3.31865 13.6663 0.333984 10.6817 0.333984 6.99967C0.333984 3.31767 3.31865 0.333008 7.00065 0.333008C10.6827 0.333008 13.6673 3.31767 13.6673 6.99967C13.6673 10.6817 10.6827 13.6663 7.00065 13.6663ZM7.00065 12.333C8.41514 12.333 9.77169 11.7711 10.7719 10.7709C11.7721 9.77072 12.334 8.41416 12.334 6.99967C12.334 5.58519 11.7721 4.22863 10.7719 3.22844C9.77169 2.22824 8.41514 1.66634 7.00065 1.66634C5.58616 1.66634 4.22961 2.22824 3.22941 3.22844C2.22922 4.22863 1.66732 5.58519 1.66732 6.99967C1.66732 8.41416 2.22922 9.77072 3.22941 10.7709C4.22961 11.7711 5.58616 12.333 7.00065 12.333ZM6.33598 9.66634L3.50732 6.83767L4.44998 5.89501L6.33598 7.78101L10.1067 4.00967L11.05 4.95234L6.33598 9.66634Z"
        fill={color}
      />
    </svg>
  );
}

CheckHollowIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default CheckHollowIcon;
